.healthAndSpellSlots {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  /* biome-ignore lint/suspicious/noDuplicateProperties: 100vh used as fallback for browsers that don't support svh */
  height: 100svh;
  padding: 16px 0;
  z-index: 3;
  animation: slideUp 300ms;
  display: grid;
  grid-template-rows: auto 1fr auto;
  accent-color: var(--color-accent);

  > * {
    padding-left: 20px;
    padding-right: 20px;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 16px;
    border-bottom: 1px solid var(--color-parchment-dark);

    h2 {
      font-size: 20px;
      margin: 0;
    }

    button {
      width: 44px;
      height: 44px;
      border-radius: 50%;
      border: none;
      text-decoration: none;
      padding: 0;

      svg {
        width: 24px;
        height: 24px;
        flex-shrink: 0;
        fill: var(--color-accent);
        transition: transform 300ms;
      }
    }

    .iconOpen {
      transform: rotate(180deg);
    }
  }

  h3 {
    font-size: 16px;
  }

  input[type="number"],
  input[type="text"] {
    display: block;
    width: 100%;
    font-size: 16px;
    padding: 8px 16px;
    border: 1px solid var(--color-text);
    color: var(--color-text);
    border-radius: 4px;
    background: var(--color-bg-white);
  }

  .content {
    overflow-y: auto;
    padding-bottom: 16px;
  }

  .health {
    display: grid;
    grid-template-columns: 1fr minmax(75px, auto);
    gap: 8px;

    label {
      font-size: 14px;
      display: grid;
      grid-template-columns: subgrid;
      grid-column: span 2;

      input[type="range"] {
        cursor: ew-resize;

        &:hover {
          accent-color: var(--color-accent-hover);
        }
      }
    }
  }

  .characterClasses {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .newClassSelectLabel {
    font-weight: bold;
    display: block;
    margin: 16px 0 8px;
  }

  .footer {
    border-top: 1px solid var(--color-parchment-dark);
    display: flex;
    gap: 8px;
    padding-top: 16px;
  }
}

@media (min-width: 716px) {
  main:has(.healthAndSpellSlots) {
    padding-right: calc(375px + 20px);
  }

  .healthAndSpellSlots {
    left: auto;
    right: 0;
    bottom: 0;
    z-index: 1;
    top: 48px;
    width: 375px;
    height: auto;
    max-height: calc(100vh - 48px);
    /* biome-ignore lint/suspicious/noDuplicateProperties: 100vh used as fallback for browsers that don't support svh */
    max-height: calc(100svh - 48px);
    border: 1px solid var(--color-parchment-dark);
    animation: slideLeft 300ms;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(200px);
  }
}

@keyframes slideLeft {
  from {
    opacity: 0;
    transform: translateX(200px);
  }
}
